// src/Components/TerminalList.jsx
import React from 'react';
import styles from '../Pages/TerminalManagement.module.css';

const TerminalList = React.memo(({ terminals, onEdit, onDelete }) => {
  
  if (!terminals || terminals.length === 0) {
    return (
      <p className={styles.emptyMessage}>No hay terminales registrados.</p>
    );
  }

  return (
    <div className={styles.tableContainer}>
      <table className={styles.terminalTable}>
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Dirección</th>
            <th>Teléfono</th>
            <th className={styles.actionsHeader}>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {terminals.map(terminal => (
            <tr key={terminal.id} className={styles.terminalTableRow}>
              <td>{terminal.name}</td>
              <td>{terminal.address}</td>
              <td>{terminal.tel_number}</td>
              <td className={styles.actionsCell}>
                <button 
                  onClick={() => onEdit(terminal)} 
                  className={styles.buttonEdit}
                >
                  Editar
                </button>
                <button 
                  onClick={() => onDelete(terminal.id)} 
                  className={styles.buttonDelete}
                >
                  Eliminar
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
});

export default TerminalList;